/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';
import { t } from 'utils/translates';
import StatusLabel from '../StatusLabel';
import TasksUpListPopUp from '../../TasksUpListPopUpNew';
import TimeTargetOptionsPopUp from '../TimeTargetOptionsPopUp';
import TaskGeoTargetState from '../CheckGeotargetAccess/TaskGeoTargetState/TaskGeoTargetState';

class TaskParamsBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTaskUpListPopUp: false
    };
  }

  render() {
    return (
      <div
        className="tab-pane active"
        id={`tabOptionsTask-${this.props.task.id}`}
      >
        {this.state.showTaskUpListPopUp ? (
          <TasksUpListPopUp
            taskModel={this.props.task}
            upListFastenNow={this.props.task.upListFastenNow}
            upListMarkNow={this.props.task.upListMarkNow}
            hideTaskUpListPopUp={() => {
              this.setState({ showTaskUpListPopUp: false });
            }}
            refreshTaskItem={() => this.props.refreshTaskItem()}
          />
        ) : null}
        <TimeTargetOptionsPopUp
          id={`timeTargetInfo-task${this.props.task.id}`}
          timeTarget={this.props.task.timeTarget}
        />
        <div className="row offset_bottom offset_bottom_xs">
          <div className="col-xs-24 col-sm-12">
            <dl className="dl-options dl-options-sm dl-horizontal task-options-left">
              <dt>{t('Категория')}:</dt>
              <dd>{this.props.task.taskTypeDesc}</dd>
              <dt>{t('Статус')}:</dt>
              <dd>
                <StatusLabel status={this.props.task.status} />
                {this.props.task.status === 5 && this.props.task.lock ? (
                  <div className="m-b-10 m-t-10">
                    {this.props.task.lock.reasonText}
                  </div>
                ) : null}
              </dd>
              <dt>{t('Дата изменения')}:</dt>
              <dd>
                <span className="text-success">
                  {formatter.dateFormat3(this.props.task.updatedAt)}
                </span>
              </dd>
              <dt>{t('Закрепить')}:</dt>
              <dd>
                <a
                  href=""
                  onClick={e => {
                    e.preventDefault();
                    this.setState({ showTaskUpListPopUp: true });
                  }}
                >
                  {this.props.task.upListFastenNow ? (
                    <React.Fragment>
                      {t('<span class="text-success">Да</span>, продлить')}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {t('<span class="text-danger">Нет</span>, включить')}
                    </React.Fragment>
                  )}
                </a>
              </dd>
              <dt>{t('Выделить')}:</dt>
              <dd>
                <a
                  href=""
                  onClick={e => {
                    e.preventDefault();
                    this.setState({ showTaskUpListPopUp: true });
                  }}
                >
                  {this.props.task.upListMarkNow ? (
                    <React.Fragment>
                      {t('<span class="text-success">Да</span>, продлить')}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {t('<span class="text-danger">Нет</span>, включить')}
                    </React.Fragment>
                  )}
                </a>
              </dd>
            </dl>
          </div>
          <div className="col-xs-24 col-sm-12">
            <dl className="dl-options dl-options-sm dl-horizontal task-options-right">
              <dt>{t('Цена выполнения')}:</dt>
              <dd>{this.props.task.totalCostExecution} ₽</dd>
              <dt>{t('Кол. выполнений')}:</dt>
              <dd>
                {t('{current} из {from}', {
                  current: this.props.task.statFinishedExecs,
                  from: this.props.task.maxExecutions
                })}
              </dd>
              <dt title="Таргетинг по времени">{t('Таргетинг по времени')}:</dt>
              <dd>
                {this.props.task.timeTarget &&
                this.props.task.timeTarget.length > 0 ? (
                  <a
                    data-toggle="modal"
                    href={`#timeTargetInfo-task${this.props.task.id}`}
                  >
                    {t('<span class="text-success">Есть</span>, узнать')}
                  </a>
                ) : (
                  <React.Fragment>{t('Нет')}</React.Fragment>
                )}
              </dd>
              <dt title={t('Геотаргетинг')}>{t('Геотаргетинг')}:</dt>
              <dd>
                <TaskGeoTargetState task={this.props.task} />
              </dd>
            </dl>
          </div>
        </div>
      </div>
    );
  }
}

TaskParamsBlock.defaultProps = {
  refreshTaskItem: () => {}
};

TaskParamsBlock.propTypes = {
  refreshTaskItem: PropTypes.func,
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    taskTypeDesc: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    totalCostExecution: PropTypes.string.isRequired,
    statFinishedExecs: PropTypes.number.isRequired,
    tasksExecsStat: PropTypes.shape({}).isRequired,
    maxExecutions: PropTypes.number.isRequired,
    timeTarget: PropTypes.arrayOf(PropTypes.shape).isRequired,
    hasGeoTarget: PropTypes.bool.isRequired,
    lock: PropTypes.shape({
      reasonText: PropTypes.string.isRequired
    }),
    upListFastenNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    upListMarkNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    updatedAt: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(TaskParamsBlock);



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskParamsBlock/TaskParamsBlock.js